<svelte:head>
  <title>Offers | A Good Thing</title>
</svelte:head>

<h1 class="title">Current offers from local businesses</h1>

<h2 class="is-size-4 mb-5">
  <div class="field has-addons">
    <div class="control is-expanded">
      <PostcodeInput bind:postcode />
    </div>
    <div class="control">
      <div class="select" style="font-size:1rem;">
        <select bind:value={distance}>
          <option value={1} selected={distance === 1}>1 mile</option>
          <option value={2} selected={distance === 2}>2 miles</option>
          <option value={3} selected={distance === 3}>3 miles</option>
          <option value={5} selected={distance === 5}>5 miles</option>
          <option value={10} selected={distance === 10}>10 miles</option>
          <option value={20} selected={distance === 20}>20 miles</option>
          <option value={30} selected={distance === 30}>30 miles</option>
          <option value={50} selected={distance === 50}>50 miles</option>
        </select>
      </div>
    </div>
  </div>
</h2>

<h2 class="is-size-6 mb-5">
  {#if loading}
    Loading offers...
  {:else if postcode}
    {#if items.length > 0}
      Showing offers from local businesses near {postcode}.
    {:else}
      Sorry, there are no items on offer within {distance} mile{distance > 1
        ? 's'
        : ''} of {postcode}.
    {/if}
  {:else}
    Showing offers from businesses in all locations. Enter your postcode to find
    local offers.
  {/if}
</h2>

<OffersList {items} />

{#if postcode && nationwideItems && nationwideItems.length > 0}
  <hr class="mt-6" />
  <h2 class="subtitle is-size-4">Offers available nationwide via post</h2>
  <div class="block">
    <OffersList items={nationwideItems} />
  </div>
{/if}

<script lang="ts">
  import _ from 'lodash';
  import PostcodeInput from '../_components/PostcodeInput.svelte';
  import OffersList from './_components/OffersList.svelte';

  let loading = false;

  let items: any[] = [];

  let allNationwideItems: any[];
  $: nationwideItems =
    allNationwideItems && items
      ? _.differenceWith(allNationwideItems, items, (a, b) => a.id != b.id)
      : undefined;

  let firebase = window.firebase;

  let postcode = '';
  let distance = 20;

  $: getOffers(postcode, distance);

  getNationwideOffers();

  async function getOffers(postcode: string, distance: number) {
    let params;

    if (postcode) {
      const location: any = await getPostcode(postcode);

      params = {
        long: location.longitude,
        lat: location.latitude,
        distance,
      };
    }

    loading = true;

    firebase
      .functions()
      .httpsCallable('api-offer-getoffers')(params)
      .then((response) => {
        items = response.data;
      })
      .finally(() => {
        loading = false;
      });
  }

  async function getNationwideOffers() {
    const result = await firebase
      .firestore()
      .collection('published_offers_v1')
      .where('options.nationwide', '==', true)
      .get();

    allNationwideItems = result.docs.map((doc: any) => ({
      id: doc.id,
      data: doc.data(),
    })) as any[];
  }

  async function getPostcode(postcode: string) {
    return fetch(`https://api.postcodes.io/postcodes/${postcode}`)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        return data.result;
      });
  }
</script>
